import React, { useEffect, useState } from "react";
import Image from "../../assets/images/png/tractor-add-img.png";
import clock from "../../assets/images/png/clock-icon.png";
import LikeIcon from "../../assets/images/png/like-img.png";
import { getFeaturedAdds } from "../../services/FeaturedAdds";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const FeatureAdds = ({ mt0, mt5, textwhite, whitehrline, bgwhite }) => {
  const [data, setData] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const getAds = async () => {
    const res = await getFeaturedAdds();
    setData([res]);
  };

  useEffect(() => {
    getAds();
  }, []);

  const convertToRelativeTime = (createdAt) => {
    const currentTime = new Date();
    const createdTime = new Date(createdAt);
    const timeDifference = Math.abs(currentTime - createdTime);

    const seconds = Math.floor(timeDifference / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 0) {
      return `posted ${days} day${days > 1 ? "s" : ""} ago`;
    } else if (hours > 0) {
      return `posted ${hours} hour${hours > 1 ? "s" : ""} ago`;
    } else if (minutes > 0) {
      return `posted ${minutes} minute${minutes > 1 ? "s" : ""} ago`;
    } else {
      return `posted just now`;
    }
  };

  const featureaddRelaod = (valueid) => {
    navigate(`/profile-details/${valueid}`);
  };

  const stripHTMLTags = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  return (
    <div className="row mt-3">
      {data.map((value, index) => (
        <div key={index}>
          <h4
            className={`text-uppercase ${mt5} ff_heebo clr_dark_blue ${textwhite} fs_md lh-26 fw-bold ${mt0}`}
          >
            Featured Ads
          </h4>
          <div className="light-grey-hr-line w-100 position-relative">
            <div
              className={`green-hr-line green-hr-line-width ${whitehrline}`}
            ></div>
          </div>
          <div
            className="cursor-pointer"
            onClick={() => featureaddRelaod(value._id)}
          >
            <div className="mt-4">
              <div className="rounded-3 product-border bg-dark-purple">
                <div className="position-relative">
                  <img
                    style={{ borderRadius: "6px 6px 0 0" }}
                    height={200}
                    className="w-100 object-fit-cover"
                    src={value?.images}
                    alt="Image"
                  />
                </div>
                <div className={`p-3 ${bgwhite ? "bg-white" : ""}`}>
                  <div className="d-flex align-items-center">
                    <div className="bg-danger px-3 py-1 rounded-2">
                      <p
                        style={{ marginBottom: "2px" }}
                        className="text-white text-capitalize"
                      >
                        {value?.adType}
                      </p>
                    </div>
                    <p
                      className={`clr_dark_green ff_heebo fs_4xsm ms-3 mb-0 ${
                        bgwhite ? "text-black" : "text-white"
                      }`}
                    >
                      {value?.machineType} / Agri Equipments
                    </p>
                  </div>
                  <h3
                    className={`ff_heebo fs_md my-3 fw-medium ${
                      bgwhite ? "text-black " : "text-white"
                    }`}
                  >
                    {stripHTMLTags(value?.description)
                      .split(" ")
                      .slice(0, 15)
                      .join(" ")}
                  </h3>
                  <div className="mt-3">
                    <span className="text-yellow fs_xxl ff_heebo fw-bold">
                      ₹{value?.price}/
                      <span className="fs_xxsm fw-normal">
                        {value?.priceType}
                      </span>
                    </span>
                    <div className="d-flex align-items-center gap-2 mt-2">
                      <div style={{ display: "contents" }}>
                        <img width={15} src={clock} alt="image" />
                      </div>
                      <span
                        className={`ff_heebo ${
                          bgwhite ? "text-black" : "text-white"
                        } fw-light d-flex m-0 p-0`}
                      >
                        {convertToRelativeTime(value?.createdAt)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FeatureAdds;
